import script from "./SelectBranch.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBranch.vue?vue&type=script&setup=true&lang=js"

import "./SelectBranch.vue?vue&type=style&index=0&id=7e656b21&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e656b21"]])

export default __exports__